import {Component, OnInit, Renderer2} from '@angular/core';

import QRCode from 'qrcode-generator';
import {ActivatedRoute} from '@angular/router';
import {finalize} from 'rxjs';
import {FormBuilder} from '@angular/forms';
import {AppService} from '@services/app.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import { AesEncryptionService } from '@services/aes-encryption.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent implements OnInit {

    currentYear = new Date().getFullYear();
    qrCodeImg: string = "";
    ticketSeq: string = "";
    ticketDetails: any;

    constructor(
        private fb: FormBuilder,
        private appService: AppService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private aesService: AesEncryptionService
    ) {}

    ngOnInit(): void {
  this.route.queryParams.subscribe((params) => {
    const encryptedId = params['ticketNo'];

    if (encryptedId) {
      
      // 1. URL decode only (AES encrypted Base64 may contain + / =)
      const cleanBase64 = decodeURIComponent(encryptedId);

      // 2. Decrypt using AES
      this.ticketSeq = this.aesService.decrypt(cleanBase64);

      console.log("Decrypted ticketSeq:", this.ticketSeq);

      this.getMyTicketById();
    }
  });
}


    getMyTicketById() {
        this.spinner.show();
        this.appService.getTicketById(this.ticketSeq)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe({
                next: async (data) => {
                    console.log(data);

                    this.ticketDetails = data;

                    // WAIT for QR to finish generating
                    this.qrCodeImg = await this.generateQRCode(this.ticketSeq);
                },

                error: (err) => this.toastr.error(err.error?.message || err.message)
            });
    }

// 🔹 generate QR + transparent background
    async generateQRCode(ticketNo: string): Promise<string> {
        const qr = QRCode(0, 'M');
        qr.addData(ticketNo);
        qr.make();

        const cellSize = 4;
        const margin = 0;

        const dataURL = qr.createDataURL(cellSize, margin);

        return await this.convertWhiteToTransparent(dataURL);
    }

// 🔹 convert white → transparent asynchronously
    private convertWhiteToTransparent(dataUrl: string): Promise<string> {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = dataUrl;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d")!;

                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;

                for (let i = 0; i < data.length; i += 4) {
                    const r = data[i];
                    const g = data[i + 1];
                    const b = data[i + 2];

                    // Black pixels → WHITE
                    if (r < 50 && g < 50 && b < 50) {
                        data[i] = 255;     // R
                        data[i + 1] = 255; // G
                        data[i + 2] = 255; // B
                        data[i + 3] = 255; // Opaque
                    }

                    // White pixels → Transparent
                    if (r > 240 && g > 240 && b > 240) {
                        data[i + 3] = 0; // transparent
                    }
                }

                ctx.putImageData(imageData, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
        });
    }





}
